var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-renderer",class:{ 'page-renderer--editing': _vm.editMode }},[_c('page-node-children',{attrs:{"page-id":_vm.pageId,"parent-id":null,"edit-mode":_vm.editMode}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }